export let post_config = [
    {
        elements: [
			// {
			// 	elementGetParamMap: 'test_checkbox',
			// 	elementType: 'checkbox',
			// 	element_model: false,
			// 	placeholder: '',
			// 	label: 'Некачественный лид',
			// 	show_fields: 'true:test_select-typeoperation',
			// },
			{
				elementGetParamMap: 'test_radio-group-quality',
				element_model: '2',
				elementType: 'radio-group',
				label: 'Качественный ли?',
				options: [{name: '1', label: 'Качественный',},{name: '0', label: 'Некачественный',}]
			},
			{
				elementGetParamMap: 'test_radio-group-obj',
				element_model: '2',
				elementType: 'radio-group',
				label: 'По объекту ли?',
				options: [{name: '1', label: 'По объекту',},{name: '0', label: 'Не по объекту',}],
				show_fields: '1:test_input-imposter;0:test_select-typeoperation,test_select-typeobj,test_radio-group-newbuilding,test_ajax_list,test_input-imposter-call',
			},
			{
				elementGetParamMap: 'test_input-imposter',
				element_model: '',
				elementType: 'input',
				placeholder: 'Это имитация другого компонента',
				label: 'Это имитация другого компонента',
				auto_hidden:true,
			},
			{
				elementGetParamMap: 'test_select-typeoperation',
				elementCat: 'cat_position',
				elementType: 'select',
				element_model: '',
				label: 'Тип операций',
				placeholder: 'Выберите тип',
				options:[
					{value: '1', label: '1',},
					{value: '2', label: '2',},
					{value: '3', label: '3',},
				],
				auto_hidden:true
			},
			{
				elementGetParamMap: 'test_select-typeobj',
				elementCat: 'cat_position',
				elementType: 'select',
				element_model: '',
				label: 'Тип объекта',
				placeholder: 'Выберите тип',
				options:[
					{value: '1', label: '1',},
					{value: '2', label: '2',},
					{value: '3', label: '3',},
				],
				auto_hidden:true
			},
			{
				elementGetParamMap: 'test_radio-group-newbuilding',
				element_model: '2',
				elementType: 'radio-group',
				label: 'Новостройка ли',
				options: [{name: '1', label: 'Новостройка',},{name: '0', label: 'Вторичка',}],
				auto_hidden:true
			},
			{
				elementGetParamMap: 'test_ajax_list',
				elementType: 'ajax-list',
				element_model: {},
				label: 'Ответственный',
				placeholder:"Выбрать сотрудника",
				objApiMethod:{'obj':'staff' ,'flt':{'fio':''}},
				strApiMethodKey:"fio",
				auto_hidden:true
			},
			{
				elementGetParamMap: 'test_input-imposter-call',
				element_model: '',
				elementType: 'input',
				placeholder: 'Это имитация кнопки для звонка агенту',
				label: 'Это имитация кнопки для звонка агенту',
				auto_hidden:true,
			},
			{
				elementGetParamMap: 'test_radio-group-agent',
				element_model: '2',
				elementType: 'radio-group',
				label: 'Агент ли?',
				options: [{name: '0', label: 'Агент',},{name: '1', label: 'Собственник',}]
			},
			{
				elementGetParamMap:"uData",
				elementCat:"CONTACTS_TYPES",
				element_model:[
					{contact_id:"",contact_type:"",contact_value:"",contact_view:"",contact_group:"phone"}
				],
				elementType:"input-contact",
				delMethod:{apiMetho:"DEL_CONTACT",apiParam:{obj:"staff",flt:{code:"",contact_id:""}}},
				label:"Телефон",
				placeholder:"Введите номер",
				contactGroup:"phone",
				contactGroup_options:[
					{value:"1",label:"Телефон моб."},
					{value:"2",label:"Телефон раб."}
				],
				copyFrom:'contacts',
			},
			{
				elementGetParamMap: 'test_input',
				element_model: '',
				elementType: 'input',
				placeholder: 'Название',
				label: 'Название'
			},
			{
				elementGetParamMap: 'test_input',
				element_model: '',
				elementType: 'input',
				placeholder: 'ИНН',
				label: 'ИНН'
			},
			{
				elementGetParamMap: 'test_input',
				element_model: '',
				elementType: 'input',
				placeholder: 'ИНН',
				label: 'ИНН'
			},
			{
				elementGetParamMap: 'test_input',
				element_model: '',
				elementType: 'input',
				placeholder: 'КПП',
				label: 'КПП'
			},
			{
				elementGetParamMap: 'test_input',
				element_model: '',
				elementType: 'input',
				placeholder: 'ОКПО',
				label: 'ОКПО'
			},
			{
				elementGetParamMap: 'test_input',
				element_model: '',
				elementType: 'input',
				placeholder: 'ОГРН',
				label: 'ОГРН'
			},
			{
				elementGetParamMap: 'test_select-source',
				elementCat: 'cat_position',
				elementType: 'select',
				element_model: '',
				label: 'Рекламный источник',
				placeholder: 'Выберите источник',
				options:[
					{value: '1', label: '1',},
					{value: '2', label: '2',},
					{value: '3', label: '3',},
				]
			},
			{
				elementGetParamMap: 'test_input',
				element_model: '',
				elementType: 'textarea',
				placeholder: 'Примемчание',
				label: 'Пиши в меня'
			},

        ]
    }
]